import React, { useEffect } from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import CartDrawer from '../components/cart/CartDrawer';
import { CONTACT_INFO, siteImages, CARD_DESCRIPTOR } from '../data/mock';

const PrivacyPage = () => {
  useEffect(() => {
    document.title = 'Privacy Policy | Keto Vybe';
  }, []);

  return (
    <div className="min-h-screen bg-slate-950">
      <Header />
      <CartDrawer />
      
      <main className="pt-20">
        {/* Banner */}
        <section className="relative h-64 lg:h-72 overflow-hidden">
          <img 
            src={siteImages.privacyBanner}
            alt="Privacy Policy"
            className="w-full h-full object-cover opacity-40"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/70 to-slate-950/50" />
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="text-center">
              <span className="text-vybe-400 font-semibold text-sm tracking-wider uppercase mb-3 block">Legal</span>
              <h1 className="font-display text-4xl lg:text-5xl text-white mb-3">
                Privacy Policy
              </h1>
              <p className="text-slate-400">How we protect your information</p>
            </div>
          </div>
        </section>

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="bg-slate-800/50 rounded-3xl p-8 lg:p-12 border border-slate-700/50">
            <div className="prose prose-invert max-w-none">
              <p className="text-slate-400 leading-relaxed mb-8">
                At Keto Vybe, operated by {CONTACT_INFO.corpName}, we are committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or make a purchase.
              </p>

              <h2 className="font-display text-xl text-white mt-8 mb-4">Information We Collect</h2>
              <p className="text-slate-400 leading-relaxed mb-4">
                We collect information that you provide directly to us, including:
              </p>
              <ul className="list-disc pl-6 text-slate-400 space-y-2 mb-6">
                <li>Name and contact information (email address, phone number, shipping address)</li>
                <li>Payment information (credit card details processed securely through our payment processor)</li>
                <li>Order history and product preferences</li>
                <li>Communications with our customer support team</li>
              </ul>

              <h2 className="font-display text-xl text-white mt-8 mb-4">How We Use Your Information</h2>
              <p className="text-slate-400 leading-relaxed mb-4">
                We use the information we collect to:
              </p>
              <ul className="list-disc pl-6 text-slate-400 space-y-2 mb-6">
                <li>Process and fulfill your orders</li>
                <li>Communicate with you about your orders and our products</li>
                <li>Provide customer support</li>
                <li>Improve our website and services</li>
                <li>Comply with legal obligations</li>
              </ul>

              <h2 className="font-display text-xl text-white mt-8 mb-4">Payment Information</h2>
              <p className="text-slate-400 leading-relaxed mb-6">
                All payment transactions are processed securely. We do not store your full credit card information on our servers. Your payment details are encrypted and processed by our secure payment gateway. All charges will appear as "{CARD_DESCRIPTOR}" on your credit card statement.
              </p>

              <h2 className="font-display text-xl text-white mt-8 mb-4">Data Security</h2>
              <p className="text-slate-400 leading-relaxed mb-6">
                We implement appropriate technical and organizational security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. Our website uses SSL encryption to secure data transmission.
              </p>

              <h2 className="font-display text-xl text-white mt-8 mb-4">Third-Party Disclosure</h2>
              <p className="text-slate-400 leading-relaxed mb-6">
                We do not sell, trade, or otherwise transfer your personally identifiable information to outside parties except for trusted third parties who assist us in operating our website, conducting our business, or servicing you, so long as those parties agree to keep this information confidential.
              </p>

              <h2 className="font-display text-xl text-white mt-8 mb-4">Your Rights</h2>
              <p className="text-slate-400 leading-relaxed mb-4">
                You have the right to:
              </p>
              <ul className="list-disc pl-6 text-slate-400 space-y-2 mb-6">
                <li>Access the personal information we hold about you</li>
                <li>Request correction of inaccurate information</li>
                <li>Request deletion of your personal information</li>
                <li>Opt-out of marketing communications</li>
              </ul>

              <h2 className="font-display text-xl text-white mt-8 mb-4">Contact Us</h2>
              <p className="text-slate-400 leading-relaxed">
                If you have any questions about this Privacy Policy, please contact us at:
              </p>
              <div className="bg-slate-900/50 border border-vybe-500/30 rounded-xl p-6 mt-4">
                <p className="text-white font-medium">{CONTACT_INFO.corpName}</p>
                <p className="text-slate-400">{CONTACT_INFO.address.street}</p>
                <p className="text-slate-400">{CONTACT_INFO.address.city}, {CONTACT_INFO.address.state} {CONTACT_INFO.address.zip}</p>
                <p className="text-slate-400">Email: {CONTACT_INFO.email}</p>
                <p className="text-slate-400">Phone: {CONTACT_INFO.phone}</p>
              </div>

              <p className="text-slate-500 text-sm mt-8">
                Last updated: July 2025
              </p>
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default PrivacyPage;
